export function shouldTrackAnalytics(pathname: string): boolean {
  if (__IS_PREVIEW__) return false;
  return !pathname.startsWith("/admin");
}
